import { createApp } from 'vue'
import App from './App.vue'
import './styles/main.css'
import { useErrorLog } from './composables/useErrorLog'

const app = createApp(App)
const { captureError } = useErrorLog()

// ── Vue Error Handler ────────────────────────────────────────────────────────
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err)

  const componentName = instance?.$options?.name
    || instance?.$options?.__name
    || instance?.$.type?.name
    || instance?.$.type?.__name
    || 'UnknownComponent'

  const componentFile = instance?.$.type?.__file || ''

  captureError(err, {
    component: componentName,
    function: info,
    module: 'vue-error-handler',
    file: componentFile,
    severity: 'error',
    context: { vueInfo: info },
  })
}

// ── Global JS Error Handler ──────────────────────────────────────────────────
window.onerror = (message, source, lineno, colno, error) => {
  captureError(error || new Error(String(message)), {
    function: 'window.onerror',
    module: 'runtime',
    file: source || '',
    line: lineno || null,
    column: colno || null,
    severity: 'error',
    context: { source, lineno, colno },
  })
}

// ── Unhandled Promise Rejection Handler ──────────────────────────────────────
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error
    ? event.reason
    : new Error(String(event.reason))

  captureError(error, {
    function: 'unhandledrejection',
    module: 'promise',
    severity: 'error',
    context: {
      reason: String(event.reason),
      promiseState: 'rejected',
    },
  })
})

app.mount('#app')
